import { render, staticRenderFns } from "./DataTable-Dialogs.vue?vue&type=template&id=119f1217"
import script from "./DataTable-Dialogs.vue?vue&type=script&lang=ts"
export * from "./DataTable-Dialogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports